module.exports = __webpack_public_path__ + "static/media/janmesh-joshi.85bbcf98.jpeg";